import { ORDER_INFO_SELECT, ORDER_INFO_INVALIDATE } from 'src/constants/ActionTypes';
import { IStateOrder } from 'src/entity/StateEntity';

const initialState: IStateOrder = {
  orderInfo: undefined,
  type: ORDER_INFO_INVALIDATE,
};

export const orderState = (state: IStateOrder = initialState, action: IStateOrder): IStateOrder => {
  switch (action.type) {
    case ORDER_INFO_SELECT:
      return Object.assign({}, state, {
        type: action.type,
        orderInfo: action.orderInfo,
      });
    case ORDER_INFO_INVALIDATE:
      return Object.assign({}, state, {
        type: action.type,
        orderInfo: undefined,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/orderState.ts